import { useRouter } from 'next/router'

//* HOCs
import { withUserContext } from 'context'

//* Components
import { Text, CustomLink, Logo, ButtonSimple, Container, Icon, Image } from 'components/common'

//* Style
import FooterStyle from './style'

const AppFooter = (props) => {
    const router = useRouter()

    const handleDebateCreate = () => {
        if (props.isLoggedIn) {
            router.push('/profile/debate/create')
        } else {
            router.push(`${router.asPath}?c=login`)
        }
    }

    return (
        <FooterStyle>
            <Container className='flexBox spaceBetween'>
                <div className='left-block flexBox spaceBetween'>
                    <Logo />
                    <ButtonSimple
                        onClick={handleDebateCreate}
                        className='ftr-btn'
                        text='Create debate'
                    />
                    <div className='pages flexBox'>
                        <div className='page flexBox'>
                            <CustomLink url='/faq'>
                                <Text tag={'h5'} className={'h5 PopReg darkGrey'} text={'FAQ'} />
                            </CustomLink>
                        </div>
                        <div className='page flexBox'>
                            <CustomLink url='/contact-us'>
                                <Text tag={'h5'} className={'h5 PopReg darkGrey'} text={'Contact Us'} />
                            </CustomLink>
                        </div>
                        <div className='page flexBox'>
                            <CustomLink url='/about-us'>
                                <Text tag={'h5'} className={'h5 PopReg darkGrey'} text={'About Us'} />
                            </CustomLink>
                        </div>
                        <div className='page flexBox'>
                            <CustomLink url='/privacy-policy'>
                                <Text tag={'h5'} className={'h5 PopReg darkGrey'} text={'Privacy Policy'} />
                            </CustomLink>
                        </div>
                    </div>
                </div>
                <div className='social flexBoxColumn'>
                    <div className='block flexBox'>
                        <a aria-label='oplos-faceboook' target='_blank' href='https://www.facebook.com/oplos.net'>
                            <Icon className='op-facebook' />
                        </a>
                        <a aria-label='oplos-linkedin' target='_blank' href='https://www.linkedin.com/company/oplos/'>
                            <Icon className='op-linkedin' />
                        </a>
                        <a aria-label='oplos-instagram' target='_blank' href='#'>
                            <Icon className='op-instagram' />
                        </a>
                        <a aria-label='oplos-twitter' target='_blank' href='#'>
                            <Icon className='op-twitter' />
                        </a>
                    </div>
                    <div className='footer-logo flexBox'>
                        <Text tag='p' className='h7 PopReg grey' text='Designed by' />
                        <a aria-label='design-by' target='_blank' href='https://flexy.global/'>
                            <Image className='logo' src='/images/flexy.svg' />
                        </a>
                    </div>
                </div>
            </Container>
        </FooterStyle>
    )
}

export default withUserContext(AppFooter, ['isLoggedIn'])
